import React from 'react';
import { Box, Flex, Icon, Link, SimpleGrid, Stack, Text, VStack } from '@chakra-ui/react';
import { PhoneIcon, MailIcon, MapPinIcon, VideoIcon } from 'lucide-react';
import { WhatsAppIcon } from './WhatsAppIcon';
import { SealButton } from './SealButton';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { brand, videoCallHref, whatsappHref } from '../data/brand';
const channels = [{
  icon: WhatsAppIcon,
  label: 'WhatsApp',
  value: brand.whatsapp,
  href: whatsappHref(),
  external: true
}, {
  icon: PhoneIcon,
  label: 'Teléfono',
  value: brand.phone,
  href: brand.phoneHref,
  external: false
}, {
  icon: MailIcon,
  label: 'Correo',
  value: brand.email,
  href: brand.emailHref,
  external: false
}, {
  icon: MapPinIcon,
  label: 'Ubicación',
  value: 'Miami, Florida',
  href: undefined,
  external: false
}, {
  icon: VideoIcon,
  label: 'Videollamada',
  value: 'Agenda tu consulta',
  href: videoCallHref,
  external: true
}];
export function Contact() {
  return <Box as="section" id="contacto" bg="ink.900" position="relative" overflow="hidden" pt={{
    base: 16,
    md: 28
  }} pb={{
    base: 16,
    md: 24
  }} mt={{
    md: '-4vw'
  }} sx={{
    clipPath: {
      base: 'none',
      md: 'polygon(0 0, 100% 4vw, 100% 100%, 0 100%)'
    }
  }} data-id="element-38" data-mp="3jw4kc69mxv2l">
      {/* Animated smoke layers (CSS only) */}
      <Box position="absolute" inset="-15%" pointerEvents="none" aria-hidden="true" bg="radial-gradient(38% 42% at 25% 35%, rgba(196,18,48,0.28) 0%, rgba(13,13,13,0) 70%), radial-gradient(30% 30% at 70% 20%, rgba(242,183,5,0.14) 0%, rgba(13,13,13,0) 70%)" animation="smokeDriftA 26s ease-in-out infinite" data-id="element-39" data-mp="315d0ubvxooah" />
      <Box position="absolute" inset="-15%" pointerEvents="none" aria-hidden="true" bg="radial-gradient(34% 36% at 78% 72%, rgba(196,18,48,0.22) 0%, rgba(13,13,13,0) 70%), radial-gradient(28% 28% at 18% 85%, rgba(242,183,5,0.12) 0%, rgba(13,13,13,0) 70%)" animation="smokeDriftB 34s ease-in-out infinite" data-id="element-40" data-mp="2w6a4dfu0rqe4" />

      <Box px={{
      base: 5,
      md: 10,
      xl: 16
    }} position="relative" data-id="element-41" data-mp="1ybfyf1himkid">
        <Reveal data-id="element-42" data-mp="1uavyjq5k52sj">
          <SectionHeading eyebrow="Estamos para escucharte" title="Consulta con nosotros" description="Comunícate con nuestro equipo para conocer nuestros servicios y resolver tus preguntas." tone="dark" data-id="element-43" data-mp="1uadwue04lwd8" />
        </Reveal>

        <SimpleGrid columns={{
        base: 1,
        sm: 2,
        lg: 5
      }} spacing={{
        base: 4,
        md: 5
      }} mt={{
        base: 10,
        md: 16
      }} maxW="82rem" mx="auto" data-id="element-44" data-mp="2i0gpav7yd4cd">
          {channels.map((channel, index) => {
          const card = <VStack align="flex-start" spacing={4} h="100%" px={6} py={7} bg="rgba(250,243,232,0.06)" backdropFilter="blur(14px)" border="1px solid" borderColor="rgba(250,243,232,0.16)" boxShadow="0 18px 44px rgba(0,0,0,0.35)" transition="all 0.3s ease" _hover={channel.href ? {
            borderColor: 'rgba(242,183,5,0.6)',
            transform: 'translateY(-4px)',
            bg: 'rgba(250,243,232,0.1)'
          } : undefined} sx={{
            clipPath: 'polygon(0 0, 100% 0, 100% 86%, 88% 100%, 0 100%)'
          }} data-id="element-45" data-mp="288knpa6nqw3e">
                <Flex align="center" justify="center" w="2.75rem" h="2.75rem" borderRadius="full" bg="rgba(196,18,48,0.9)" color="cream.50" data-id="element-46" data-mp="4utg2ih38ocm">
                  <Icon as={channel.icon} boxSize="1.15rem" aria-hidden="true" data-id="element-47" data-mp="it07bfrj7q3b" />
                </Flex>
                <Box minW={0} data-id="element-48" data-mp="5614xz04kz3w">
                  <Text fontSize="0.68rem" letterSpacing="0.24em" textTransform="uppercase" color="gold.400" mb={1} data-id="element-49" data-mp="559jhh08shrc">
                    {channel.label}
                  </Text>
                  <Text fontSize={{
                base: 'sm',
                md: 'md'
              }} color="cream.50" wordBreak="break-word" data-id="element-50" data-mp="9y2ps9bczy5j">
                    {channel.value}
                  </Text>
                </Box>
              </VStack>;
          return <Reveal key={channel.label} delay={index * 0.06} data-id="element-51" data-mp="3sbimrf2n198o" data-mpi={index}>
                {channel.href ? <Link href={channel.href} isExternal={channel.external} display="block" h="100%" _hover={{
              textDecoration: 'none'
            }} data-id="element-52" data-mp="3ncfj9z2b3b2t">
                    {card}
                  </Link> : card}
              </Reveal>;
        })}
        </SimpleGrid>

        <VStack spacing={5} mt={{
        base: 12,
        md: 16
      }} data-id="element-53" data-mp="2pjzco5rim3kf">
          <Stack direction={{
          base: 'column',
          sm: 'row'
        }} spacing={3} w={{
          base: '100%',
          sm: 'auto'
        }} data-id="element-54" data-mp="2pgjzj8hej4ln">
            <SealButton href={whatsappHref()} external tone="whatsapp" label="Escribir por WhatsApp" caption={brand.whatsapp} icon={<WhatsAppIcon size={19} data-id="element-56" data-mp="3884eh7om3egl" />} data-id="element-55" data-mp="2gj16phxinlz7" />
            <SealButton href={brand.phoneHref} tone="phone" label="Llamar ahora" caption={brand.phone} ariaLabel={`Llamar al ${brand.phone}`} icon={<PhoneIcon size={18} aria-hidden="true" data-id="element-58" data-mp="3n6eu57jxz17z" />} data-id="element-57" data-mp="2ui98mil2d873" />
            <SealButton href={videoCallHref} external tone="gold" label="Agendar videollamada" caption="Por WhatsApp" icon={<VideoIcon size={18} aria-hidden="true" data-id="element-60" data-mp="5ln11ir9ewf3" />} data-id="element-59" data-mp="3rxepw9hbrd8w" />
          </Stack>
          <Text fontSize="sm" color="cream.200" opacity={0.7} textAlign="center" data-id="element-61" data-mp="mtmro45f1dv">
            Atendemos consultas de personas mayores de 18 años.
          </Text>
        </VStack>
      </Box>
    </Box>;
}